import ActiveMessageTemplateInputVariablesView from './ActiveMessageTemplateInputVariablesView.html';
export class ActiveMessageTemplateInputVariablesController {
}
export const ActiveMessageTemplateInputVariablesComponent = {
    template: ActiveMessageTemplateInputVariablesView,
    controller: ActiveMessageTemplateInputVariablesController,
    controllerAs: '$ctrl',
    bindings: {
        customMessageTemplate: '<',
        messageTemplateVariables: '<',
        messageTemplateButtonsVariables: '<',
        onPreviewChange: '<',
        onVariableChange: '<',
        inputMedia: '<',
    },
};
